import React from 'react';
import { Card, CardContent } from '../components/ui/card';
import { MapPin, Phone } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { cities, companyInfo } from '../data/mock';

const Zone = () => {
  return (
    <div className="min-h-screen">
      {/* Hero Section */}
      <section className="bg-gradient-to-br from-stone-50 to-amber-50 py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center max-w-3xl mx-auto">
            <h1 className="text-4xl md:text-5xl font-bold text-stone-900 mb-6">
              Zone d'intervention
            </h1>
            <p className="text-xl text-stone-600">
              Nous intervenons dans toute la région {companyInfo.zone}
            </p>
          </div>
        </div>
      </section>

      {/* Main Content */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-2 gap-12 items-start">
            {/* Text Content */}
            <div className="space-y-6">
              <h2 className="text-3xl font-bold text-stone-900">
                Toute la région Hauts-de-France
              </h2>
              <p className="text-lg text-stone-600 leading-relaxed">
                Les Façadiers HDF intervient dans l'ensemble de la région Hauts-de-France 
                pour tous vos projets de ravalement de façade, isolation thermique par l'extérieur, 
                nettoyage et traitement de façades.
              </p>
              <p className="text-lg text-stone-600 leading-relaxed">
                Notre proximité avec nos clients nous permet d'intervenir rapidement pour 
                établir un devis gratuit et de réaliser vos travaux dans les meilleurs délais.
              </p>
              <div className="bg-amber-50 p-6 rounded-xl border border-amber-200">
                <h3 className="text-xl font-semibold text-stone-900 mb-3">
                  Votre ville n'est pas listée ?
                </h3>
                <p className="text-stone-600 mb-4">
                  Contactez-nous ! Nous étudions toutes les demandes dans la région Hauts-de-France.
                </p>
                <Link to="/contact">
                  <Button className="bg-amber-600 hover:bg-amber-700 text-white">
                    <Phone className="w-4 h-4 mr-2" />
                    Nous contacter
                  </Button>
                </Link>
              </div>
            </div>

            {/* Cities List */}
            <Card className="border-stone-200">
              <CardContent className="p-8">
                <h3 className="text-2xl font-bold text-stone-900 mb-6 flex items-center">
                  <MapPin className="w-6 h-6 mr-2 text-amber-600" />
                  Principales villes
                </h3>
                <div className="grid grid-cols-2 gap-4">
                  {cities.map((city, index) => (
                    <div
                      key={index}
                      className="flex items-center space-x-2 text-stone-700 hover:text-amber-600 transition-colors"
                    >
                      <div className="w-2 h-2 bg-amber-600 rounded-full"></div>
                      <span>{city}</span>
                    </div>
                  ))}
                </div>
                <div className="mt-6 pt-6 border-t border-stone-200">
                  <p className="text-sm text-stone-600 italic">
                    Et toutes les villes environnantes de la région Hauts-de-France
                  </p>
                </div>
              </CardContent>
            </Card>
          </div>
        </div>
      </section>

      {/* Map Placeholder */}
      <section className="py-20 bg-stone-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-stone-900 mb-4">
              Notre zone de couverture
            </h2>
            <p className="text-lg text-stone-600">
              Toute la région Hauts-de-France
            </p>
          </div>
          <div className="bg-white rounded-2xl overflow-hidden shadow-lg">
            <div className="aspect-video bg-gradient-to-br from-stone-100 to-amber-50 flex items-center justify-center">
              <div className="text-center space-y-4">
                <MapPin className="w-16 h-16 text-amber-600 mx-auto" />
                <div className="text-2xl font-semibold text-stone-900">
                  Hauts-de-France
                </div>
                <div className="text-stone-600">
                  Nord (59) - Pas-de-Calais (62) - Somme (80) - Aisne (02) - Oise (60)
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl md:text-4xl font-bold text-stone-900 mb-6">
            Besoin d'un devis ?
          </h2>
          <p className="text-xl text-stone-600 mb-8">
            Contactez-nous dès maintenant pour une estimation gratuite et sans engagement
          </p>
          <Link to="/contact">
            <Button size="lg" className="bg-amber-600 hover:bg-amber-700 text-white">
              <Phone className="w-5 h-5 mr-2" />
              Demander un devis
            </Button>
          </Link>
        </div>
      </section>
    </div>
  );
};

export default Zone;